import { api } from "./client";

export interface SkillDimension {
  key: string;
  label: string;
  value: number;
  raw: number | null;
  cohort_avg: number | null;
  description: string;
}

export interface SkillProfile {
  dimensions: SkillDimension[];
  flights_sampled: number;
}

export interface MissionProgressPoint {
  flight_id: number;
  date: string | null;
  best_lap_seconds: number | null;
  avg_speed_mps: number | null;
}

export interface MissionProgress {
  mission_name: string | null;
  best_lap_seconds: number | null;
  best_lap_flight_id: number | null;
  attempts: number;
  completed_laps: number;
  rank: number | null;
  trend: MissionProgressPoint[];
  improvement_seconds: number | null;
}

export interface AltitudeSample {
  elapsed_seconds: number;
  altitude_m: number;
}

export interface AltitudeProfile {
  flight_id: number | null;
  session_name: string | null;
  min_m: number | null;
  max_m: number | null;
  avg_m: number | null;
  samples: AltitudeSample[];
}

export interface PilotInsightsOut {
  skill_profile: SkillProfile;
  mission_progress: MissionProgress;
  altitude_profile: AltitudeProfile;
}

export function getPilotInsights() {
  return api.get<PilotInsightsOut>("/api/insights/pilot");
}
